import { SerializedStyles } from "@emotion/react";
import { ReactNode, Ref, memo, useCallback } from "react";
import { FormFlowPage } from "src/components";
import { IdVerifyPrompt } from "src/icons";

export interface IdVerificationPreambleLayoutProps {
  focusRef?: Ref<HTMLInputElement>;
  onNext: () => void;
  onBack: () => void;
  style?: SerializedStyles;
  children?: ReactNode;
  nextLoading?: boolean;
}

const IdVerificationPreambleLayout = ({
  focusRef,
  onNext,
  onBack,
  style,
  children,
  nextLoading,
  ...props
}: IdVerificationPreambleLayoutProps) => {
  const handleOnNext = useCallback(
    (evt: React.ChangeEvent<HTMLFormElement>) => {
      evt?.preventDefault();
      onNext?.();
    },
    [onNext]
  );

  return (
    <FormFlowPage
      {...props}
      ref={focusRef}
      icon={<IdVerifyPrompt width={150} height="100%" />}
      title="Let's verify your identity"
      description={
        "This information helps us safely validate your identity. The data you provide to " +
        "verify your identity is only available to you and the credit bureaus. " +
        "This isn’t a credit check, and we don't store personal information from these questions."
      }
      onNext={handleOnNext}
      onBack={onBack}
      style={style}
      nextLoading={nextLoading}
    >
      {children}
    </FormFlowPage>
  );
};

export default memo(IdVerificationPreambleLayout);
